module.exports = __webpack_public_path__ + "static/media/136.7b853abb.png";